import { render, staticRenderFns } from "./UsuariosRoles.vue?vue&type=template&id=19728f92&scoped=true"
import script from "./UsuariosRoles.vue?vue&type=script&lang=js"
export * from "./UsuariosRoles.vue?vue&type=script&lang=js"
import style0 from "./UsuariosRoles.vue?vue&type=style&index=0&id=19728f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19728f92",
  null
  
)

export default component.exports